/** @jsxImportSource @emotion/react */
import { BaseSyntheticEvent, useState } from "react";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { SubmitHandler, Controller, Control, UseFormRegister, FieldError, UseFormWatch } from "react-hook-form";
import { UploadFile } from "../../common/Util";
import { ResponseParamBase } from "../../common/Types";
import configcss from "../../css/config.module.css";
import { ApiUrl } from "../../common/Params";
import { IFormInputs } from "../Config";
import { InputBase } from "@mui/material";

export const TextEditType = {
    chatTitle: "chatTitle",
    footerText: "footerText",
    questionTemplate: "questionTemplate",
} as const
export type TextEditType = typeof TextEditType[keyof typeof TextEditType]

export type TextEditProp = {
    textValue: string,
    type: TextEditType,
    onChangeText: (text: string, type: TextEditType) => void,
    control: Control<IFormInputs>,
    register: UseFormRegister<IFormInputs>,
    error: FieldError | undefined,
    watch: UseFormWatch<IFormInputs>
}

/*type IFormInputs = {
    textValue: string,
    footerText: string,
    type: TextEditType,
}*/

type ResponseParam = ResponseParamBase & {
    updateValue: string
}

/*const schema = Yup.object({    
    textValue: TextValidation(true, 1, 100)
}).required();*/

export const TextEdit = (prop: TextEditProp): ReactJSXElement => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    /*const {register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid }} = useForm<IFormInputs>({
        defaultValues: {
            textValue: prop.textValue,
            type: prop.type,
        },
        mode: "onBlur",
        reValidateMode: "onBlur",
        resolver: yupResolver(schema),
    });*/

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        await UploadFile<ResponseParam>(
            ApiUrl.UpdateTextValue,
            data,
            setIsLoading,
        ).then((response) => {   
            prop.onChangeText(response.data.updateValue, prop.type)
        })
    }
    
    return(
        <>
        <div className={configcss['infoBox']}>
            <div className={`${configcss['infoBoxInner']} ${configcss['mdlBox']}`}>
                <div className={`${configcss['infoBoxInner-sub']} ${configcss['layoutBox']}`}>
                    <Controller
                        name={prop.type}
                        control={prop.control}
                        render={({field}) => (
                            prop.type === "questionTemplate" ?
                                <InputBase {...field} {...prop.register(prop.type)} multiline maxRows={5} className={configcss['infoTextArea']}></InputBase>
                            :
                                <input type="text" {...field} {...prop.register(prop.type)}></input>
                        )}
                    />
                    <div className={configcss['error']}>{prop.error?.message}</div>
                </div>
            </div>
        </div>
        </>
    );
}